import { nanoid } from "nanoid"
import QRCode from 'react-qr-code';
import { QRCode as QRCodeCanvas } from 'react-qrcode-logo';
import Barcode from 'react-barcode';

const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // border: '1px solid #000',
        overflow: 'hidden',
        paddingLeft: '5px'
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '2px',
        width: '100%',
        height: '100%',
        // padding: '5px',
        boxSizing: 'border-box',
    },
    rowContent: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        // padding: '5px',
    },
    text: {
        fontWeight: 'bold',
        textAlign: 'center',
        // fontSize: '10px',
    }
};
const styles1 = {
    container: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        // border: '1px solid #000',
        overflow: 'hidden',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
    },
    rowContent: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '10px',
    },
    text: {
        fontWeight: 'bold',
        textAlign: 'center',
    }
};
const framesConfig = {

    collection: {
        key: "{{_id}}",
        section: 'collections',
        pageType: 'collection',
        fetchUrl: 'getRecords',
        addUrl: 'postRecord',
        editUrl: 'updateRecord',
        removeUrl: 'removeRecord',
        postBody: { hub: "{{appletHub}}", applet: '{{appletId}}' },
        filter: { hub: "{{appletHub}}", applet: '{{appletId}}' },
    },


    tasklist: {
        key: "{{_id}}",
        section: 'collections',
        pageType: 'collection',
        fetchUrl: 'getMyTasks',
        addUrl: 'addTask',
        editUrl: 'updateTask',
        removeUrl: 'removeTask',
        postBody: { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{appletId}}' },
        filter: { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{appletId}}' },
    },

    planner: {
        key: "{{_id}}",
        section: 'collections',
        pageType: 'collection',
        fetchUrl: 'getMyTasks',
        addUrl: 'addTask',
        editUrl: 'updateTask',
        removeUrl: 'removeTask',
        postBody: { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{appletId}}' },
        filter: { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{appletId}}' },
    },

    sprint: {
        key: "{{_id}}",
        section: 'pages',
        pageType: 'classifier',
        fetchUrl: 'getMyTasks',
        addUrl: 'addTask',
        editUrl: 'updateTask',
        removeUrl: 'removeTask',
        postBody: { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{appletId}}' },
        filter: { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{appletId}}' },
    },


    drive: {
        key: "{{_id}}",
        section: 'drive',
        pageType: 'drive',
        fetchUrl: 'getRecords',
        addUrl: 'postRecord',
        editUrl: 'updateRecord',
        removeUrl: 'removeRecord',
        postBody: { hub: "{{appletHub}}", applet: '{{appletId}}' },
        filter: { hub: "{{appletHub}}", applet: '{{appletId}}' },
    },


    messenger: {
        key: "{{_id}}",
        section: 'messengers',
        pageType: 'messenger',
        fetchUrl: 'getRecords',
        addUrl: 'postRecord',
        editUrl: 'updateRecord',
        removeUrl: 'removeRecord',
        postBody: { hub: "{{appletHub}}", applet: '{{appletId}}' },
        filter: { hub: "{{appletHub}}", applet: '{{appletId}}' },
    },


    page: {
        key: "{{_id}}",
        section: 'pages',
        pageType: 'page',
        fetchUrl: 'getRecords',
        addUrl: 'postRecord',
        editUrl: 'postRecord',
        removeUrl: 'removeRecord',
        postBody: { hub: "{{appletHub}}", applet: '{{appletId}}' },
        filter: { hub: "{{appletHub}}", applet: '{{appletId}}' },
    },

    calendar: {
        key: "{{_id}}",
        section: 'pages',
        pageType: 'calendar',
        fetchUrl: 'getRecords',
        addUrl: 'postRecord',
        editUrl: 'postRecord',
        removeUrl: 'removeRecord',
        postBody: { hub: "{{appletHub}}", applet: '{{appletId}}' },
        filter: { hub: "{{appletHub}}", applet: '{{appletId}}' },
    },

    project: {
        key: "{{_id}}",
        section: 'pages',
        pageType: 'page',
        fetchUrl: 'getMyTasks',
        addUrl: 'addTask',
        editUrl: 'updateTask',
        removeUrl: 'removeTask',
        postBody: { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{appletId}}' },
        filter: { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{appletId}}' },
    },

    rooms: {
        key: "{{_id}}",
        section: 'pages',
        pageType: 'rooms',
        // fetchUrl: 'getMyTasks',
        // addUrl: 'addTask',
        // editUrl: 'updateTask',
        // removeUrl: 'removeTask',
        postBody: { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{appletId}}' },
        filter: { hub: "{{appletHub}}", applet: '{{appletId}}', frame: '{{appletId}}' },
    },




    paymentGateways: {
        key: "{{_id}}",
        section: 'collection',
        pageType: 'collection',
        fetchUrl: 'getPaymentTypes',
        addUrl: 'postPaymentType',
        editUrl: 'postPaymentType',
        removeUrl: 'removePaymentType',

        postBody: { hub: "{{appletHub}}", applet: '{{appletId}}' },
        filter: { hub: "{{appletHub}}", applet: '{{appletId}}' },
    },


    taxes: {
        key: "{{_id}}",
        section: 'collection',
        pageType: 'collection',
        fetchUrl: 'getTaxes',
        addUrl: 'postTax',
        editUrl: 'postTax',
        removeUrl: 'removeTax',

        postBody: { hub: "{{appletHub}}", applet: '{{appletId}}' },
        filter: { hub: "{{appletHub}}", applet: '{{appletId}}' },
    },




    invoices: {
        key: "{{_id}}",
        section: 'collection',
        pageType: 'collection',
        fetchUrl: 'getInvoices',
        addUrl: 'postInvoice',
        editUrl: 'editInvoice',
        removeUrl: 'removeInvoice',

        postBody: { hub: "{{appletHub}}", applet: '{{appletId}}' },
        filter: { hub: "{{appletHub}}", applet: '{{appletId}}' },
    },


    payments: {
        key: "{{_id}}",
        section: 'collection',
        pageType: 'collection',
        fetchUrl: 'getPayments',
        addUrl: 'postPayment',
        removeUrl: 'removePayment',

        postBody: { hub: "{{appletHub}}", applet: '{{appletId}}' },
        filter: { hub: "{{appletHub}}", applet: '{{appletId}}' },
    },


    accounts: {
        key: "{{_id}}",
        section: 'collection',
        pageType: 'collection',
        fetchUrl: 'getAccounts',
        addUrl: 'postAccount',
        removeUrl: 'removeAccount',

        postBody: { hub: "{{appletHub}}", applet: '{{appletId}}' },
        filter: { hub: "{{appletHub}}", applet: '{{appletId}}' },
    },




    products: {
        key: "{{_id}}",
        section: 'collection',
        pageType: 'collection',
        fetchUrl: 'getProducts',
        addUrl: 'postProduct',
        removeUrl: 'removeProduct',

        postBody: { hub: "{{appletHub}}", applet: '{{appletId}}' },
        filter: { hub: "{{appletHub}}", applet: '{{appletId}}' },
    },

}
// style={{ ...styles.container, width:300*(scale ?? 1), height:150*(scale ?? 1),padding:10*(scale ?? 1),fontSize:12*(scale??1),gap:10*(scale??1)}}
const LABELTEMPLATES = {
    template11: {
        key: 'qrLeftTextRightBarcode',
        render: (code, text1, text2, title, scale = 1, widthMM = 35, heightMM = 25, qrcode) => {
            const width = (widthMM * 3.78) * scale;  // Convert mm to pixels
            const height = (heightMM * 3.78) * scale;
            return (
                <div style={{ ...styles.container, width: `${width}px`, height: `${height}px` }}>
                    <div style={styles.content}>
                        <div style={{ ...styles.rowContent, maxHeight: '46%' }}>
                            <div style={styles.content}>
                                <div style={{ ...styles.text, fontSize: scale * 7.7,marginRight:'4px' }}>{text1}</div>
                            </div>
                            <QRCode value={qrcode ?? code} size={43 * scale} />
                        </div>
                        <div style={{ ...styles.content, width: '90%', maxHeight: '38%' }}>
                            <Barcode fontSize={12 * scale} value={code} width={2.4 * scale} height={35 * scale} />
                        </div>
                        <div style={{ ...styles.rowContent, maxHeight: '16%' }}>

                            <div style={{ ...styles.text, fontSize: scale * 7.7, marginLeft:'10%' }}>{text2}</div>
                            <div style={{ ...styles.text, fontSize: scale * 7.7 }}>{title}</div>

                        </div>
                    </div>
                </div>
            );
        }
    },
    template1: {
        key: 'qrTopTextBottom',
        render: (code, text1, text2, title, scale = 1, widthMM = 35, heightMM = 25) => {
            const width = (widthMM * 3.78) * scale;  // Convert mm to pixels
            const height = (heightMM * 3.78) * scale;
            return (
                <div style={{ ...styles.container, width: `${width}px`, height: `${height}px` }}>
                    <div style={styles.content}>
                        <QRCode value={code} size={widthMM * scale} />
                        <div style={{ ...styles.text, fontSize: scale * 6 }}>{title}</div>
                        <div style={{ ...styles.text, fontSize: scale * 6 }}>{text1}</div>
                        <div style={{ ...styles.text, fontSize: scale * 6 }}>{text2}</div>
                    </div>
                </div>
            );
        }
    },

    template2: {
        key: 'qrLeftTextRight',
        render: (code, text1, text2, title, scale = 1, widthMM = 35, heightMM = 25) => {
            const width = (widthMM * 3.78) * scale;  // Convert mm to pixels
            const height = (heightMM * 3.78) * scale;
            return (
                <div style={{ ...styles.container, width: `${width}px`, height: `${height}px` }}>
                    <div style={styles.rowContent}>
                        <QRCode value={code} size={widthMM * scale} />
                        <div style={styles.content}>
                            <div style={{ ...styles.text, fontSize: scale * 6 }}>{title}</div>
                            <div style={{ ...styles.text, fontSize: scale * 6 }}>{text1}</div>
                            <div style={{ ...styles.text, fontSize: scale * 6 }}>{text2}</div>
                        </div>
                    </div>
                </div>
            );
        }
    },
    template3: {
        key: 'barcodeTopTextBottom',
        render: (code, text1, text2, title, scale = 1, widthMM = 35, heightMM = 25) => {
            const width = (widthMM * 3.78) * scale;  // Convert mm to pixels
            const height = (heightMM * 3.78) * scale;
            return (
                <div style={{ ...styles.container, width: `${width}px`, height: `${height}px` }}>
                    <div style={styles.content}>
                        <div style={{ width: '100%', padding: '0 5px' }}>
                            <Barcode fontSize={15 * scale * 0.9} value={code} width={((width / (widthMM * 1.5)) * scale)} height={heightMM * 0.7 * scale} />
                        </div>
                        <div style={{ ...styles.text, fontSize: scale * 6 }}>{title}</div>
                        <div style={{ ...styles.text, fontSize: scale * 6 }}>{text1}</div>
                        <div style={{ ...styles.text, fontSize: scale * 6 }}>{text2}</div>
                    </div>
                </div>
            );
        }
    },
    template7: {
        key: 'barcodeTopTextBottom',
        render: (code, text1, text2, title, scale = 1, widthMM = 35, heightMM = 25) => {
            const width = (widthMM * 3.78) * scale;  // Convert mm to pixels
            const height = (heightMM * 3.78) * scale;
            return (
                <div style={{ ...styles.container, width: `${width}px`, height: `${height}px` }}>
                    <div style={styles.content}>
                        <div style={{ ...styles.text, fontSize: scale * 6 }}>{title}</div>
                        <div style={{ width: '100%', padding: '0 5px' }}>
                            <Barcode fontSize={15 * 0.9 * scale} value={code} width={((width / (widthMM * 1.5)) * scale)} height={heightMM * 0.7 * scale} />
                        </div>
                        <div style={{ ...styles.text, fontSize: scale * 6 }}>{text1}</div>
                        <div style={{ ...styles.text, fontSize: scale * 6 }}>{text2}</div>
                    </div>
                </div>
            );
        }
    },
    template8: {
        key: 'barcodeTopTextBottom',
        render: (code, text1, text2, title, scale = 1, widthMM = 35, heightMM = 25) => {
            const width = (widthMM * 3.78) * scale;  // Convert mm to pixels
            const height = (heightMM * 3.78) * scale;
            return (
                <div style={{ ...styles.container, width: `${width}px`, height: `${height}px` }}>
                    <div style={styles.content}>
                        <div style={{ ...styles.text, fontSize: scale * 6 }}>{title}</div>
                        <div style={{ width: '100%', padding: '0 5px' }}>
                            <Barcode fontSize={15 * scale} value={code} width={((width / (widthMM * 1.5)) * scale)} height={heightMM * 0.9 * scale} />
                        </div>

                        <div style={styles.rowContent}>

                            <div style={{ ...styles.text, fontSize: scale * 6 }}>{text1}</div>
                            <div style={{ ...styles.text, fontSize: scale * 6 }}>{text2}</div>
                        </div>
                    </div>
                </div>
            );
        }
    },
    template4: {
        key: 'barcodeLeftTextRight',
        render: (code, text1, text2, title, scale = 1, widthMM = 35, heightMM = 25) => {
            const width = (widthMM * 3.78) * scale;  // Convert mm to pixels
            const height = (heightMM * 3.78) * scale;
            return (
                <div style={{ ...styles.container, width: `${width}px`, height: `${height}px` }}>
                    <div style={styles.rowContent}>
                        <div style={{ width: '60%', padding: '0 5px' }}>
                            <Barcode fontSize={15 * scale} value={code} width={((width / (widthMM * 3.3)) * scale)} height={heightMM * 0.9 * scale} />
                        </div>
                        <div style={styles.content}>
                            <div style={{ ...styles.text, fontSize: scale * 6 }}>{title}</div>
                            <div style={{ ...styles.text, fontSize: scale * 6 }}>{text1}</div>
                            <div style={{ ...styles.text, fontSize: scale * 6 }}>{text2}</div>
                        </div>
                    </div>
                </div>
            );
        }
    },
    template5: {
        key: 'qrBarcodeSideBySide',
        render: (code, text1, text2, title, scale = 1, widthMM = 35, heightMM = 25) => {
            const width = (widthMM * 3.78) * scale;  // Convert mm to pixels
            const height = (heightMM * 3.78) * scale;
            return (
                <div style={{ ...styles.container, width: `${width}px`, height: `${height}px` }}>
                    <div style={styles.rowContent}>
                        <QRCode value={code} size={widthMM * scale} />
                        <div style={{ width: '60%' }}>
                            <Barcode fontSize={15 * scale} value={code} width={((width / (widthMM * 3.3)) * scale)} height={heightMM * 0.9 * scale} />
                        </div>
                    </div>
                </div>
            );
        }
    },
    template6: {
        key: 'qrBarcodeStacked',
        render: (code, text1, text2, title, scale = 1, widthMM = 35, heightMM = 25) => {
            const width = (widthMM * 3.78) * scale;  // Convert mm to pixels
            const height = (heightMM * 3.78) * scale;
            return (
                <div style={{ ...styles.container, width: `${width}px`, height: `${height}px` }}>
                    <div style={styles.content}>
                        <QRCode value={code} size={widthMM * scale} />
                        <Barcode fontSize={15 * scale} value={code} width={((width / (widthMM * 1.5)) * scale)} height={heightMM * 0.9 * scale} />
                    </div>
                </div>
            );
        }
    },

    template9: {
        key: 'modernLabelStyle',
        render: (code, text1, text2, title, scale = 1, widthMM = 35, heightMM = 25) => {
            const width = (widthMM * 3.78) * scale;  // Convert mm to pixels
            const height = (heightMM * 3.78) * scale;
            return (
                <div style={{ ...styles.container, width: `${width}px`, height: `${height}px` }}>
                    <div style={styles.content}>
                        <div style={{ ...styles.text, fontSize: scale * 6, fontSize: 12 * scale }}>{title}</div>
                        <QRCode value={code} size={widthMM * scale} />
                        <div style={{ ...styles.text, fontSize: scale * 6 }}>{text1}</div>
                        <div style={{ ...styles.text, fontSize: scale * 6 }}>{text2}</div>
                    </div>
                </div>
            );
        }
    },
    template10: {
        key: 'modernLabelStyle',
        render: (code, text1, text2, title, scale = 1, widthMM = 35, heightMM = 25) => {
            const width = (widthMM * 3.78) * scale;  // Convert mm to pixels
            const height = (heightMM * 3.78) * scale;
            return (
                <div style={{ ...styles.container, width: `${width}px`, height: `${height}px` }}>
                    <div style={styles.content}>
                        <div style={{ ...styles.text, fontSize: scale * 6, fontSize: 12 * scale }}>{title}</div>
                        <QRCode value={code} size={widthMM * scale} />
                        <div style={styles.rowContent}>

                            <div style={{ ...styles.text, fontSize: scale * 6 }}>{text1}</div>
                            <div style={{ ...styles.text, fontSize: scale * 6 }}>{text2}</div>
                        </div>
                    </div>
                </div>
            );
        }
    }
};

const LABELTEMPLATESSTATIC = {
    template1: {
        key: 'qrTopTextBottom',
        render: (code, text1, text2, title, scale = 1) => (
            <div style={{ ...styles1.container, width: 350 * scale, height: 190 * scale, padding: 10 * scale, fontSize: 12 * scale }}>
                <div style={styles1.content}>
                    <QRCode value={code} size={50 * scale} />
                    <div style={{ ...styles1.text }}>{title}</div>
                    <div style={{ ...styles1.text }}>{text1}</div>
                    <div style={{ ...styles1.text }}>{text2}</div>
                </div>
            </div>
        ),
    },
    template2: {
        key: 'qrLeftTextRight',
        render: (code, text1, text2, title, scale = 1) => (
            <div style={{ ...styles1.container, width: 350 * scale, height: 190 * scale, padding: 10 * scale, fontSize: 12 * scale }}>
                <div style={styles1.rowContent}>
                    <QRCode value={code} size={50 * scale} />
                    <div style={styles1.content}>
                        <div style={{ ...styles1.text }}>{title}</div>
                        <div style={{ ...styles1.text }}>{text1}</div>
                        <div style={{ ...styles1.text }}>{text2}</div>
                    </div>
                </div>
            </div>
        ),
    },
    template10: {
        key: 'qrLeftTextRightBarcode',
        render: (code, text1, text2, title, scale = 1, qrcode) => (
            <div style={{ ...styles1.container, width: 350 * scale, height: 190 * scale, padding: 10 * scale, fontSize: 12 * scale }}>
                <div style={styles1.rowContent}>
                    <QRCode value={qrcode} size={30 * scale} />
                    <div style={styles1.content}>
                        <div style={{ ...styles1.text }}>{text1}</div>
                        <div style={{ ...styles1.text }}>{text2}</div>
                    </div>
                    <div style={{ width: '90%' }}>
                        <Barcode fontSize={15 * scale} value={code} width={1 * scale} height={30 * scale} />
                    </div>
                    <div style={styles1.rowContent}>

                        <div style={{ ...styles1.text }}>{title}</div>

                        <div style={{ ...styles1.text }}>{text2}</div>
                    </div>
                </div>
            </div>
        ),
    },
    template3: {
        key: 'barcodeTopTextBottom',
        render: (code, text1, text2, title, scale = 1) => (
            <div style={{ ...styles1.container, width: 350 * scale, height: 190 * scale, padding: 10 * scale, fontSize: 12 * scale }}>
                <div style={styles1.content}>
                    <div style={{ width: '90%' }}>
                        <Barcode fontSize={15 * scale} value={code} width={1 * scale} height={30 * scale} />
                    </div>
                    <div style={{ ...styles1.text }}>{title}</div>
                    <div style={{ ...styles1.text }}>{text1}</div>
                    <div style={{ ...styles1.text }}>{text2}</div>
                </div>
            </div>
        ),
    },
    template7: {
        key: 'barcodeTopTextBottom',
        render: (code, text1, text2, title, scale = 1) => (
            <div style={{ ...styles1.container, width: 350 * scale, height: 190 * scale, padding: 10 * scale, fontSize: 12 * scale }}>
                <div style={styles1.content}>
                    <div style={{ ...styles1.text }}>{title}</div>
                    <div style={{ width: '90%' }}>
                        <Barcode fontSize={15 * scale} value={code} width={1 * scale} height={30 * scale} />
                    </div>
                    <div style={{ ...styles1.text }}>{text1}</div>
                    <div style={{ ...styles1.text }}>{text2}</div>
                </div>
            </div>
        ),
    },
    template8: {
        key: 'barcodeTopTextBottom',
        render: (code, text1, text2, title, scale = 1) => (
            <div style={{ ...styles1.container, width: 350 * scale, height: 190 * scale, padding: 10 * scale, fontSize: 12 * scale }}>
                <div style={styles1.content}>
                    <div style={{ ...styles1.text }}>{title}</div>
                    <div style={{ width: '90%' }}>
                        <Barcode fontSize={15 * scale} value={code} width={1 * scale} height={30 * scale} />
                    </div>
                    <div style={styles1.rowContent}>

                        <div style={{ ...styles1.text }}>{text1}</div>
                        <div style={{ ...styles1.text }}>{text2}</div>
                    </div>
                </div>
            </div>
        ),
    },
    template4: {
        key: 'barcodeLeftTextRight',
        render: (code, text1, text2, title, scale = 1) => (
            <div style={{ ...styles1.container, width: 350 * scale, height: 190 * scale, padding: 10 * scale, fontSize: 12 * scale }}>
                <div style={styles1.rowContent}>
                    <div style={{ width: '50%' }}>
                        <Barcode fontSize={15 * scale} value={code} width={1 * scale} height={30 * scale} />
                    </div>
                    <div style={styles1.content}>
                        <div style={{ ...styles1.text }}>{title}</div>
                        <div style={{ ...styles1.text }}>{text1}</div>
                        <div style={{ ...styles1.text }}>{text2}</div>
                    </div>
                </div>
            </div>
        ),
    },
    template5: {
        key: 'qrBarcodeSideBySide',
        render: (code, text1, text2, title, scale = 1) => (
            <div style={{ ...styles1.container, width: 350 * scale, height: 190 * scale, padding: 10 * scale, fontSize: 12 * scale }}>
                <div style={styles1.rowContent}>
                    <QRCode value={code} size={50 * scale} />
                    <div style={{ width: '60%' }}>
                        <Barcode fontSize={15 * scale} value={code} width={1 * scale} height={30 * scale} />
                    </div>
                </div>
            </div>
        ),
    },
    template6: {
        key: 'qrBarcodeStacked',
        render: (code, text1, text2, title, scale = 1) => (
            <div style={{ ...styles1.container, width: 350 * scale, height: 190 * scale, padding: 10 * scale, fontSize: 12 * scale }}>
                <div style={styles1.content}>
                    <QRCode value={code} size={50 * scale} />
                    <Barcode fontSize={15 * scale} value={code} width={1 * scale} height={30 * scale} />
                </div>
            </div>
        ),
    },
    // template7: {
    //     key: 'qrCodeOnlyVertical',
    //     render: (code, scale = 1) => (
    //         <div style={{ ...styles1.container, width: 350 * scale, height: 190 * scale, padding: 10 * scale }}>
    //             <div style={styles1.content}>
    //                 <QRCode value={code} size={100 * scale} />
    //             </div>
    //         </div>
    //     ),
    // },
    // template8: {
    //     key: 'barcodeOnlyHorizontal',
    //     render: (code, scale = 1) => (
    //         <div style={{ ...styles1.container, width: 350 * scale, height: 190 * scale, padding: 10 * scale }}>
    //             <div style={{ width: '90%' }}>
    //                 <Barcode fontSize={15*scale} value={code} width={1.5 * scale} height={40 * scale} />
    //             </div>
    //         </div>
    //     ),
    // },
    template9: {
        key: 'modernLabelStyle',
        render: (code, text1, text2, title, scale = 1) => (
            <div style={{ ...styles1.container, width: 350 * scale, height: 190 * scale, padding: 10 * scale, fontSize: 12 * scale }}>
                <div style={styles1.content}>
                    <div style={{ ...styles1.text }}>{title}</div>
                    <QRCode value={code} size={50 * scale} />
                    <div style={{ ...styles1.text }}>{text1}</div>
                    <div style={{ ...styles1.text }}>{text2}</div>
                </div>
            </div>
        ),
    },
    template10: {
        key: 'modernLabelStyle',
        render: (code, text1, text2, title, scale = 1) => (
            <div style={{ ...styles1.container, width: 350 * scale, height: 190 * scale, padding: 10 * scale, fontSize: 12 * scale }}>
                <div style={styles1.content}>
                    <div style={{ ...styles1.text }}>{title}</div>
                    <QRCode value={code} size={50 * scale} />
                    <div style={styles1.rowContent}>

                        <div style={{ ...styles1.text }}>{text1}</div>
                        <div style={{ ...styles1.text }}>{text2}</div>
                    </div>
                </div>
            </div>
        ),
    }
};

const labelSizeTemplates = {
    size1: { width: 32, height: 22 }, // Small (3.5 cm x 2.5 cm)  
    size2: { width: 36, height: 16 }, // Small (4 cm x 2 cm)  
    size3: { width: 76, height: 36 }, // Medium (8 cm x 4 cm)  
    size4: { width: 106, height: 56 }, // Large (11 cm x 6 cm)  
    size5: { width: 36, height: 36 }, // Square Small (4 cm x 4 cm)  
    size6: { width: 56, height: 56 }, // Square Medium (6 cm x 6 cm)  
    size7: { width: 106, height: 106 } // Square Large (11 cm x 11 cm)  
};
// const labelSizeTemplates = {
//     size1: { width: 30, height: 20 }, // Small (3.5 cm x 2.5 cm)  
//     size2: { width: 34, height: 15 }, // Small (4 cm x 2 cm)  
//     size3: { width: 74, height: 36 }, // Medium (8 cm x 4 cm)  
//     size4: { width: 104, height: 54 }, // Large (11 cm x 6 cm)  
//     size5: { width: 34, height: 34 }, // Square Small (4 cm x 4 cm)  
//     size6: { width: 54, height: 54 }, // Square Medium (6 cm x 6 cm)  
//     size7: { width: 104, height: 104 } // Square Large (11 cm x 11 cm)  
// };
// const labelSizeTemplates = {
//     size1: { width: 35, height: 25 }, // Small (3.5 cm x 2.5 cm)  
//     size2: { width: 40, height: 20 }, // Small (4 cm x 2 cm)  
//     size3: { width: 80, height: 40 }, // Medium (8 cm x 4 cm)  
//     size4: { width: 110, height: 60 }, // Large (11 cm x 6 cm)  
//     size5: { width: 40, height: 40 }, // Square Small (4 cm x 4 cm)  
//     size6: { width: 60, height: 60 }, // Square Medium (6 cm x 6 cm)  
//     size7: { width: 110, height: 110 } // Square Large (11 cm x 11 cm)   
// };
const paperSizeTemplates = {
    size1: { width: 35, height: 25 }, // Small (3.5 cm x 2.5 cm)  
    size2: { width: 40, height: 20 }, // Small (4 cm x 2 cm)  
    size3: { width: 80, height: 40 }, // Medium (8 cm x 4 cm)  
    size4: { width: 110, height: 60 }, // Large (11 cm x 6 cm)  
    size8: { width: 110, height: 25 }, // Large (11 cm x 6 cm)  
    size5: { width: 40, height: 40 }, // Square Small (4 cm x 4 cm)  
    size6: { width: 60, height: 60 }, // Square Medium (6 cm x 6 cm)  
    size7: { width: 110, height: 110 } // Square Large (11 cm x 11 cm)  
};



export { framesConfig, LABELTEMPLATES, labelSizeTemplates, paperSizeTemplates, LABELTEMPLATESSTATIC }